import React from 'react';
import ReactDOM from 'react-dom';

import Reports from 'components/Reports/Reports';


function initReports() {
    const elem = document.getElementById('reports-container');
    if (!elem) {
        return;
    }

    ReactDOM.render(
        <Reports />,
        elem,
    );
}


export default initReports;



// WEBPACK FOOTER //
// ./src/views/Reports.js